import React from 'react'
import {Provider} from 'react-redux'
import {BrowserRouter, Routes, Route, Navigate} from 'react-router'
import store from 'store'
import {AdminPage} from './pages/AdminPage/AdminPage'
import {GallowGamePage} from './pages/GallowGamePage/GallowGamePage'

const App: React.FC = () =>  {
  const renderGame = () => <Navigate to={`/`} replace />

  return (
    <Provider store = {store}>
      <BrowserRouter>
        <Routes>
          <Route index element={<GallowGamePage />} />
          {NODE_ENV !== 'production' && <Route path='/admin' element={<AdminPage />} />}
          <Route path='*' element={renderGame()} />
        </Routes>
      </BrowserRouter>
    </Provider>
  )
}

export default App
